// extracted by mini-css-extract-plugin
export default {"label":"MarkdownEditor_label__Davg4","inputArea":"MarkdownEditor_inputArea__R+fkN","displayArea":"MarkdownEditor_displayArea__PW5Bs"};